module.exports = __webpack_public_path__ + "img/Media_Recall_3_Set.08bd1177.png";